
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    getAllSuppliers: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            axios.get('/external-suppliers')

                .then((response) => {
                    commit('setSuppliers', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    createSupplier: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.post('/external-suppliers/', data)

                .then((response) => {
                    commit('createSupplier', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    updateSupplier: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.put('/external-suppliers/' + data.id, data)

                .then((response) => {
                    commit('updateSupplier', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    deleteSupplier: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            let backup = [...state.suppliers];

            commit('deleteSupplier', data);

            axios.delete('/external-suppliers/' + data.id)

                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    commit('setSuppliers', backup);
                    reject(error);
                });
        });
    },
};
